import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers';

// main configurations
const persistConfig = {
  key: 'root',
  storage,

  // We are telling persistor to only store these objects from redux
  whitelist: ['localStorageContainer', 'customerPersistentApi'],
};

/* ------------- Redux Configuration ------------- */

const reducerWithPersistance = persistReducer(persistConfig, rootReducer);

export default reducerWithPersistance;
